export const getDisplayPoint = (points: number): string => {
  if (points === 0) return '0.00'

  const pointsSeparated = JSON.stringify(points).split('.')
  let pointsWithDecimal!: number

  if(pointsSeparated.length > 1) {
    const decimalCoin = pointsSeparated[1]?.slice(0, 2)
    pointsWithDecimal = Number(`${pointsSeparated[0]}.${decimalCoin}`)
  }

  return new Intl.NumberFormat(
    'th', 
    { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }
  ).format(pointsWithDecimal || points)
}
